"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Card_1 = require("../../defaults/Card");
var _styled_1 = require("../../styled-components");
var _helpers_1 = require("../../helpers");
var Text_1 = __importDefault(require("./Text"));
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Hr_1 = __importDefault(require("./Hr"));
var CardElement = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  background: ", ";\n"], ["\n  position: relative;\n  background: ",
    ";\n"])), function (_a) {
    var dark = _a.dark, theme = _a.theme, defaultCss = _a.defaultCss;
    if (defaultCss === null || defaultCss === void 0 ? void 0 : defaultCss.backgroundColor)
        return defaultCss.backgroundColor;
    if (dark)
        return theme.bgDark;
    return theme.bgLight;
});
var Card = function (_a) {
    var children = _a.children, _b = _a.dark, dark = _b === void 0 ? Card_1.defaultCardConfig.dark : _b, _c = _a.padding, padding = _c === void 0 ? Card_1.defaultCardConfig.padding : _c, _d = _a.margin, margin = _d === void 0 ? Card_1.defaultCardConfig.margin : _d, titleConfig = _a.titleConfig, subtitleConfig = _a.subtitleConfig, descriptionConfig = _a.descriptionConfig, _e = _a.showHr, showHr = _e === void 0 ? false : _e, _f = _a.boxShadow, boxShadow = _f === void 0 ? '0 1px 5px rgb(0 0 0 / 20%)' : _f, hrConfig = _a.hrConfig, style = _a.style, defaultCss = _a.defaultCss, nativeProps = _a.nativeProps;
    var mergedTitleConfig = _helpers_1.merge(Card_1.defaultCardConfig.titleConfig, titleConfig);
    var mergedSubtitleConfig = _helpers_1.merge(Card_1.defaultCardConfig.subtitleConfig, subtitleConfig);
    var mergedDescriptionConfig = _helpers_1.merge(Card_1.defaultCardConfig.descriptionConfig, descriptionConfig);
    var cssToApply = __assign({ boxShadow: '0 1px 5px rgb(0 0 0 / 20%)' }, defaultCss);
    return (react_1.default.createElement(CardElement, __assign({ dark: dark, padding: padding, margin: margin, defaultCss: cssToApply }, nativeProps),
        (mergedTitleConfig === null || mergedTitleConfig === void 0 ? void 0 : mergedTitleConfig.text) && react_1.default.createElement(Text_1.default, __assign({ dark: dark }, mergedTitleConfig)),
        (mergedSubtitleConfig === null || mergedSubtitleConfig === void 0 ? void 0 : mergedSubtitleConfig.text) && (react_1.default.createElement(Text_1.default, __assign({ dark: dark }, mergedSubtitleConfig))),
        (mergedDescriptionConfig === null || mergedDescriptionConfig === void 0 ? void 0 : mergedDescriptionConfig.text) && (react_1.default.createElement(Text_1.default, __assign({ dark: dark }, mergedDescriptionConfig))),
        showHr && react_1.default.createElement(Hr_1.default, __assign({}, Card_1.defaultCardConfig.hrConfig, hrConfig)),
        children));
};
exports.default = Card;
var templateObject_1;
//# sourceMappingURL=Card.js.map